import { AppPageLayout } from "@/components/common/AppPageLayout";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/invite")({
    component: InviteLayout,
});

function InviteLayout() {
    return (
        <AppPageLayout width="md" as="div" className="flex flex-col flex-1 min-h-full">
            <Outlet />
        </AppPageLayout>
    );
}
